import React from 'react'
import { Chip, withStyles } from '@material-ui/core'
import {
	darkBlue,
	negativeB,
	negativeC,
	positiveC,
	primaryB,
	primaryC,
	secondaryB,
	yellow
} from 'asterX-UIkit/constants/colors'
import PropTypes from 'prop-types'

const styledBy = (property, mapping) => props => mapping[props[property]]

const styles = {
	root: {
		background: styledBy('color', {
			classic: secondaryB,
			blue: primaryB,
			green: positiveC,
			red: negativeC,
			yellow: yellow,
			black: '#2E2E2E',
			pink: "#ed5ab2 "
		}),
		color: styledBy('color', {
			classic: darkBlue,
			blue: primaryC,
			green: primaryC,
			red: primaryC,
			yellow: '#2E2E2E',
			black: primaryC,
			pink: '#2E2E2E'
		}),
		fontWeight: 500,
		fontSize: 12,
		paddingLeft: 4,
		paddingRight: 4,
		paddingTop: 6,
		paddingBottom: 6,
		height: 28,
		borderRadius: 24
	}
}

const AsterChip = withStyles(styles)(({ classes, color, ...other }) => (
	<Chip className={classes.root} {...other} />
))

export default AsterChip

AsterChip.propTypes = {
	color: PropTypes.oneOf([
		'classic',
		'blue',
		'green',
		'red',
		'yellow',
		'black',
		'pink',
	]),
	label: PropTypes.string
}
